import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { RoutesService } from '../services/routes/routes.service';
import { TEMPLATES } from '../services/routes/templates';
import { SiteConfigService } from '../services/site-config/site-config.service';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const routesService = inject(RoutesService);
    const siteConfigService = inject(SiteConfigService);

    const router = inject(Router);
    return next(req).pipe(
        catchError((error) => {
            const page404Id = routesService.getPageIdByTemplate(TEMPLATES[404]);
            const isStaticConfig =
                req.url.includes('/data/') || req.url.includes('/assets/data/');
            if (isStaticConfig) {
                return throwError(() => error);
            }
            if (
                req.url.includes(`pages/${page404Id}`) &&
                error.status === 404
            ) {
                return throwError(() => error);
            }
            if (error.status === 404 || error.status === 500) {
                routesService.checkRedirectionTo404();
            }
            return throwError(() => error);
        })
    );
};
